import {TS} from "../../../../../../type/ts";
import {NoExportDeclarationTransformerVisitorOptions} from "../no-export-declaration-transformer-visitor-options";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function visitExportAssignment(_options: NoExportDeclarationTransformerVisitorOptions<TS.ExportAssignment>): undefined {
	return undefined;
}
